export default __webpack_public_path__ + "static/media/img_11.de091fb4.jpg";